/* PROPOSED v2: manuals finder. Hides/shows server-rendered rows, "Show all", and the click-to-play YouTube facade.
   No fetches. The iframe (youtube-nocookie.com) is only created after the visitor presses play. */
(function(){
  var root=document.querySelector('[data-mf-root]'); if(!root) return;
  var form=root.querySelector('[data-mf-form]'), list=root.querySelector('[data-mf-list]'),
      rows=[].slice.call(list.querySelectorAll('.mf-row')), groups=[].slice.call(list.querySelectorAll('[data-mf-group]')),
      q=form.querySelector('[data-mf-q]'), cat=form.querySelector('[data-mf-cat]'), lang=form.querySelector('[data-mf-lang]'),
      vid=form.querySelector('[data-mf-video]'), shop=form.querySelector('[data-mf-shop]'),
      count=form.querySelector('[data-mf-count]'), empty=root.querySelector('[data-mf-empty]'),
      allBtn=root.querySelector('[data-mf-all]'), showAll=false, total=rows.length;
  function norm(s){return (s||'').toLowerCase().replace(/[\s\-_.\/]/g,'')}
  function filtering(){return !!(q.value.trim()||cat.value||lang.value||vid.checked||shop.checked)}
  function apply(){
    var t=norm(q.value), c=cat.value, l=lang.value, f=filtering(), n=0;
    list.classList.toggle('is-all', f||showAll);
    rows.forEach(function(el){
      var ok=!f||((!t||norm(el.dataset.search).indexOf(t)>-1)&&(!c||el.dataset.category===c)
        &&(!l||(' '+el.dataset.langs+' ').indexOf(' '+l+' ')>-1)&&(!vid.checked||el.dataset.video==='1')&&(!shop.checked||el.dataset.shop==='1'));
      el.hidden=!ok; if(ok) n++;
    });
    groups.forEach(function(g){g.hidden=f&&!g.querySelector('.mf-row:not([hidden])')});
    var shown=f?n:(showAll?total:list.querySelectorAll('.mf-row.is-feat').length);
    count.textContent=f?(n+' of '+total+' manuals match'):('Showing '+shown+' of '+total+' manuals');
    empty.hidden=n>0; if(allBtn) allBtn.parentNode.hidden=f;
    var p=new URLSearchParams(); if(q.value) p.set('q',q.value); if(c) p.set('category',c); if(l) p.set('lang',l);
    history.replaceState(null,'',location.pathname+(p.toString()?'?'+p:'')+location.hash);
  }
  if(allBtn) allBtn.addEventListener('click',function(){showAll=!showAll;allBtn.setAttribute('aria-expanded',showAll);
    allBtn.textContent=showAll?'Show fewer':allBtn.dataset.label; apply(); if(!showAll) list.scrollIntoView({block:'start'});});
  var u=new URLSearchParams(location.search); if(u.get('q')) q.value=u.get('q'); if(u.get('category')) cat.value=u.get('category'); if(u.get('lang')) lang.value=u.get('lang');
  if(location.hash.indexOf('#m-')===0){showAll=true;}
  form.addEventListener('input',apply); form.addEventListener('change',apply); form.addEventListener('reset',function(){setTimeout(apply,0)});
  /* video: the row button opens the panel (thumbnail only); pressing play swaps in the iframe */
  function play(btn,id,title){
    var f=document.createElement('iframe');
    f.src='https://www.youtube-nocookie.com/embed/'+encodeURIComponent(id)+'?autoplay=1&rel=0';
    f.title=title; f.allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'; f.allowFullscreen=true; f.referrerPolicy='strict-origin-when-cross-origin';
    btn.innerHTML=''; btn.appendChild(f); btn.dataset.playing=id;
  }
  root.addEventListener('click',function(e){
    var vb=e.target.closest('[data-mf-vbtn]');
    if(vb){e.preventDefault(); var p=document.getElementById(vb.getAttribute('aria-controls')); var open=vb.getAttribute('aria-expanded')!=='true';
      vb.setAttribute('aria-expanded',open); p.hidden=!open;
      if(!open){var fr=p.querySelector('iframe'); if(fr){var b=fr.parentNode; b.innerHTML=b.dataset.facade; delete b.dataset.playing;}}
      return;}
    var yb=e.target.closest('.mf-yt__btn');
    if(yb){e.preventDefault(); var w=yb.parentNode; w.dataset.facade=w.innerHTML; play(w,w.dataset.yt,w.dataset.title); return;}
    var more=e.target.closest('[data-mf-more]');
    if(more){var box=more.closest('.mf-vpanel').querySelector('.mf-yt'); if(!box.dataset.facade) box.dataset.facade=box.innerHTML;
      play(box,more.dataset.mfMore,more.textContent); box.closest('.mf-vpanel').querySelector('.mf-vcap').textContent=more.textContent;}
  });
  /* close an open download menu when clicking elsewhere */
  document.addEventListener('click',function(e){root.querySelectorAll('.mf-dl[open]').forEach(function(d){if(!d.contains(e.target)) d.open=false})});
  root.querySelectorAll('.mf-acc').forEach(function(d){var s=d.querySelector('summary');d.addEventListener('toggle',function(){s.setAttribute('aria-expanded',d.open?'true':'false')})});
  apply();
})();
